import gql from 'graphql-tag';

export default gql(`
query {
  getCompanyDataForCurrentUser {
    data
  }
}`);
